/* AFIQ cart drawer (snippets/afiq-cart-drawer.liquid). Renders from /cart.js.
   Registers <cart-drawer> with Dawn's interface (open, renderContents, getSectionsToRender, setActiveElement),
   so AFIQ_UI.addToCart, the PDP, Dawn's product-form and the header icon all open it unchanged.
   Merchandising: the full system is the upgrade offer; Flag 5v5 and Basics are the add rows; smaller sets are
   never pushed. Prices shown are Shopify's own cart numbers (final_line_price / total_price), so the drawer
   always shows what checkout will charge. */
/* Boots on DOMContentLoaded: this script sits before afiq-ladder.js / afiq-shop.js in the page, and needs window.AFIQ. */
(function () {
  function boot() {
  if (customElements.get('cart-drawer')) return;
  var D = window.AFIQ_DATA || { products: {}, _meta: {} }, A = window.AFIQ || {};
  var P = D.products || {}, BUNDLES = (D._meta && D._meta.bundles) || [];
  var money = function (c) { return A.$ ? A.$(c) : '$' + (c / 100).toFixed(2); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var track = function (n, p) { if (window.AFIQ_UI && AFIQ_UI.track) AFIQ_UI.track(n, p || {}); };
  var byVariant = {};
  Object.keys(P).forEach(function (k) { if (P[k].variant) byVariant[P[k].variant] = { kind: 'deck', id: k, p: P[k] }; });
  BUNDLES.forEach(function (b) { byVariant[b.variant] = { kind: 'bundle', b: b }; });
  var ELITE = BUNDLES.filter(function (b) { return b.sku === 'AFIQ-V1234-B'; })[0];
  var VOL_IDS = Object.keys(P).filter(function (k) { return P[k].kind === 'volume'; }).sort(function (a, b) { return P[a].order - P[b].order; });
  var img = function (u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };
  var post = function (url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Cart error'); return d; }); });
  };
  var isDigital = function (it) { return !it.requires_shipping && !it.gift_card; };
  var plan0 = function (r) { return r.length ? r[0].variant : null; };

  class AfiqCartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.adr-panel');
      this.body = this.querySelector('[data-adr-body]');
      this.offersEl = this.querySelector('[data-adr-offers]');
      this.ladderEl = this.querySelector('[data-adr-ladder]');
      this.totals = this.querySelector('[data-adr-totals]');
      this.codes = this.querySelector('[data-adr-codes]');
      this.countEl = this.querySelector('[data-adr-count]');
      this.cart = null; this.busy = false;
      var self = this;
      this.addEventListener('click', function (e) { self.onClick(e); });
      this.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); if (e.key === 'Tab') self.trap(e); });
      var cf = this.querySelector('[data-adr-code-form]');
      if (cf) cf.addEventListener('submit', function (e) { e.preventDefault(); self.applyCode(cf.code.value.trim()); });
      var co = this.querySelector('[data-adr-checkout]');
      if (co) co.addEventListener('click', function () { track('afiq_drawer_checkout', { value: self.cart ? self.cart.total_price / 100 : 0 }); });
      document.addEventListener('click', function (e) {
        var ic = e.target.closest('#cart-icon-bubble');
        if (!ic || e.metaKey || e.ctrlKey || /\/cart\/?$/.test(location.pathname)) return;
        e.preventDefault(); self.setActiveElement(ic); self.open();
      });
      document.addEventListener('cart:refresh', function () { self.refresh(); });
      this.refresh();
    }
    /* ---- Dawn interface ---- */
    getSectionsToRender() { return []; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents() { this.open(); }
    open() {
      var self = this;
      this.hidden = false;
      void this.offsetWidth; /* commit the unhidden state so the slide-in transition runs (no rAF: it stalls in background tabs) */
      this.classList.add('is-open');
      document.documentElement.classList.add('adr-lock');
      this.refresh().then(function () { self.panel.focus({ preventScroll: true }); });
      track('afiq_drawer_open', {});
    }
    close() {
      var self = this;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('adr-lock');
      setTimeout(function () { if (!self.classList.contains('is-open')) self.hidden = true; }, 260);
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true });
    }
    trap(e) {
      var f = [].slice.call(this.panel.querySelectorAll('a[href],button:not([disabled]),input,summary,[tabindex]:not([tabindex="-1"])')).filter(function (x) { return x.offsetParent; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
    /* ---- data ---- */
    refresh() {
      var self = this;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { self.cart = c; self.render(); return c; }).catch(function () {});
    }
    change(key, qty) {
      var self = this; if (this.busy) return; this.busy = true; this.classList.add('is-busy');
      return post('/cart/change.js', { id: key, quantity: qty }).then(function (c) { self.cart = c; self.render(); })
        .catch(function (e) { alert(e.message); }).then(function () { self.busy = false; self.classList.remove('is-busy'); });
    }
    add(items, source) {
      var self = this; if (this.busy) return; this.busy = true; this.classList.add('is-busy');
      return post('/cart/add.js', { items: items }).then(function () { return self.refresh(); })
        .catch(function (e) { alert(e.message); }).then(function () { self.busy = false; self.classList.remove('is-busy'); });
    }
    /* Swap singles (or a smaller set) for the full system: drop one of each covered deck, then add Elite. */
    upgrade(plan) {
      /* One /cart/change.js per line, re-reading the cart in between: line keys change after each edit,
         and batch /cart/update.js by key is unreliable on Shopify Bundles lines. */
      var self = this; if (this.busy || !ELITE) return; this.busy = true; this.classList.add('is-busy');
      var steps = plan.remove.map(function (r) { return r.variant; }), cart = this.cart;
      var next = function () {
        var v = steps.shift(); if (v == null) return Promise.resolve();
        var it = cart.items.filter(function (i) { return i.variant_id === v; })[0];
        if (!it) return next();
        return post('/cart/change.js', { id: it.key, quantity: it.quantity - 1 }).then(function (c) { cart = c; return next(); });
      };
      return next()
        .then(function () { return post('/cart/add.js', { items: [{ id: ELITE.variant, quantity: 1 }] }); })
        .then(function () { track('afiq_drawer_upgrade', { from: plan.label, extra: plan.diff / 100 }); if (window.AFIQ_UI && AFIQ_UI.tagUpsell) AFIQ_UI.tagUpsell('b10x-upsell-cart-upgrade-full-system'); return self.refresh(); })
        .catch(function (e) { alert(e.message); self.refresh(); })
        .then(function () { self.busy = false; self.classList.remove('is-busy'); });
    }
    applyCode(code) {
      var self = this, msg = this.querySelector('[data-adr-code-msg]');
      if (!code) return;
      var existing = ((this.cart && this.cart.discount_codes) || []).map(function (d) { return d.code; });
      post('/cart/update.js', { discount: existing.concat(code).join(',') }).then(function (c) {
        self.cart = c; self.render();
        var hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        if (msg) msg.textContent = hit && hit.applicable ? code.toUpperCase() + ' applied.' : code.toUpperCase() + " isn't valid for this cart.";
        if (!(hit && hit.applicable)) post('/cart/update.js', { discount: existing.join(',') }).then(function (c2) { self.cart = c2; self.render(); });
        track('afiq_drawer_code', { code: code, applied: !!(hit && hit.applicable) });
      }).catch(function (e) { if (msg) msg.textContent = e.message; });
    }
    removeCode(code) {
      var self = this;
      var rest = ((this.cart && this.cart.discount_codes) || []).map(function (d) { return d.code; }).filter(function (c) { return c !== code; });
      post('/cart/update.js', { discount: rest.join(',') }).then(function (c) { self.cart = c; self.render(); });
    }
    onClick(e) {
      /* backdrop, close button, or any click outside the panel */
      if (e.target.closest('[data-adr-close]') || !this.panel.contains(e.target)) { this.close(); return; }
      var q = e.target.closest('[data-adr-qty]');
      if (q) { var it = this.item(q.dataset.key); if (it) this.change(it.key, Math.max(0, it.quantity + (+q.dataset.adrQty))); return; }
      var rm = e.target.closest('[data-adr-rm]');
      if (rm) { this.change(rm.dataset.key, 0); track('afiq_drawer_remove', { product: rm.dataset.title }); return; }
      var ad = e.target.closest('[data-adr-add]');
      if (ad) {
        var tag = 'b10x-upsell-cart-' + ({ fl5: 'flag', basics: 'basics', elite: 'full-system' }[ad.dataset.adrAdd] || ad.dataset.adrAdd);
        var p = this.add([{ id: +ad.dataset.variant, quantity: 1 }], 'drawer-' + ad.dataset.adrAdd);
        if (p) p.then(function () { if (window.AFIQ_UI && AFIQ_UI.tagUpsell) AFIQ_UI.tagUpsell(tag); });
        track('afiq_drawer_add', { product: ad.dataset.adrAdd }); return;
      }
      var up = e.target.closest('[data-adr-upgrade]');
      if (up && this.plan) { this.upgrade(this.plan); return; }
      var rc = e.target.closest('[data-adr-rmcode]');
      if (rc) { this.removeCode(rc.dataset.adrRmcode); return; }
      var lnk = e.target.closest('a[href]');
      if (lnk && this.contains(lnk) && !lnk.target) this.close();
    }
    item(key) { return ((this.cart && this.cart.items) || []).filter(function (i) { return i.key === key; })[0]; }
    /* ---- view ---- */
    deckCount(c) {
      return c.items.reduce(function (n, it) { var m = byVariant[it.variant_id]; return n + (m && m.kind === 'deck' && m.p.ladder ? it.quantity : 0); }, 0);
    }
    upgradePlan(c) {
      if (!ELITE || !ELITE.available) return null;
      if (c.items.some(function (it) { return it.variant_id === ELITE.variant; })) return null;
      var remove = [], covered = [], base = 0, label = '';
      /* a smaller set in the cart: swap it */
      c.items.forEach(function (it) {
        var m = byVariant[it.variant_id];
        if (!remove.length && m && m.kind === 'bundle' && m.b.decks.length < 4) { remove.push({ variant: it.variant_id }); covered = m.b.decks.slice(); base = it.final_price; label = m.b.title; }
      });
      if (!remove.length) {
        VOL_IDS.forEach(function (v) {
          var it = c.items.filter(function (i) { return i.variant_id === P[v].variant; })[0];
          if (it) { remove.push({ variant: it.variant_id }); covered.push(v); base += it.final_price; }
        });
        label = covered.map(function (v) { return P[v].short; }).join(' + ');
      }
      /* Only worth offering when it adds volumes they don't have: all four singles already = same cards, no upgrade. */
      if (!covered.length || covered.length >= VOL_IDS.length) return null;
      var diff = ELITE.price - base;
      /* Swapping singles also changes the deck count, so the other ladder lines move tiers. Price the whole
         ladder before and after with the same rule Shopify's automatic discounts use (AFIQ.unitCents). */
      if (label !== '' && byVariant[plan0(remove)] && byVariant[plan0(remove)].kind === 'deck' && A.unitCents) {
        var n = this.deckCount(c), k = remove.length, before = 0, after = 0;
        c.items.forEach(function (it) {
          var m = byVariant[it.variant_id]; if (!m || m.kind !== 'deck' || !m.p.ladder) return;
          var gone = remove.some(function (r) { return r.variant === it.variant_id; }) ? 1 : 0;
          before += it.quantity * A.unitCents(n, it.price);
          after += (it.quantity - gone) * A.unitCents(n - k, it.price);
        });
        diff = ELITE.price + after - before;
      }
      return diff > 0 ? { remove: remove, covered: covered, diff: diff, label: label } : null;
    }
    render() {
      var c = this.cart; if (!c) return;
      var empty = !c.item_count;
      this.classList.toggle('is-empty', empty);
      if (this.countEl) this.countEl.textContent = empty ? '' : '(' + c.item_count + ')';
      this.bubble(c.item_count);
      if (empty) {
        this.ladderEl.innerHTML = '';
        this.body.innerHTML = '<div class="adr-empty"><p>Your cart is empty.</p>' +
          (ELITE ? '<a class="adr-btn" href="' + esc(ELITE.url) + '">Shop the full system</a>' : '') +
          '<a class="adr-lnk" href="/collections/all">Browse all decks</a></div>';
        this.totals.innerHTML = ''; this.codes.innerHTML = ''; if (this.offersEl) this.offersEl.innerHTML = '';
        return;
      }
      this.renderLadder(c);
      var hasPhysical = c.items.some(function (i) { return i.requires_shipping; });
      var lines = c.items.map(function (it) {
        var m = byVariant[it.variant_id], note = '';
        if (m && m.kind === 'bundle') note = m.b.decks.length + ' decks · ' + m.b.decks.map(function (d) { return P[d] ? P[d].short : d; }).join(', ');
        else if (isDigital(it)) note = 'Printable PDF · emailed instantly';
        else if (it.variant_title && it.variant_title !== 'Default Title') note = it.variant_title;
        /* Crossed-out price: the higher of Shopify's pre-discount line price and, for a set, the same decks bought singly
           (cart.js has no compare-at price; this matches the strike-through on the product page). */
        var was = it.original_line_price;
        if (m && m.kind === 'bundle') was = Math.max(was, m.b.decks.reduce(function (t, d) { return t + (P[d] ? P[d].price : 0); }, 0) * it.quantity);
        var allocs = (it.line_level_discount_allocations || []).map(function (a) { return '<span class="adr-disc">' + esc(a.discount_application.title) + ' −' + money(a.amount) + '</span>'; }).join('');
        return '<li class="adr-li">' +
          '<a class="adr-img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="72" height="72" decoding="async">' : '') + '</a>' +
          '<div class="adr-li-t"><a href="' + esc(it.url) + '"><b>' + esc(it.product_title) + '</b></a>' + (note ? '<small>' + esc(note) + '</small>' : '') + allocs +
          '<div class="adr-qty"><button type="button" data-adr-qty="-1" data-key="' + esc(it.key) + '" aria-label="Remove one ' + esc(it.product_title) + '">−</button><output>' + it.quantity + '</output><button type="button" data-adr-qty="1" data-key="' + esc(it.key) + '" aria-label="Add one ' + esc(it.product_title) + '">+</button></div></div>' +
          '<div class="adr-li-p">' + (was > it.final_line_price ? '<s>' + money(was) + '</s>' : '') + '<b>' + money(it.final_line_price) + '</b>' +
          (was > it.final_line_price ? '<em class="adr-save-tag">Save ' + money(was - it.final_line_price) + '</em>' : '') +
          '<button type="button" class="adr-rm" data-adr-rm data-key="' + esc(it.key) + '" data-title="' + esc(it.product_title) + '">Remove</button></div></li>';
      }).join('');
      var free = hasPhysical ? '<li class="adr-li adr-free"><span class="adr-img adr-free-art">' +
        ['afiq-free-qb-gameweek-homework.jpg', 'afiq-free-qb-session-checklist.jpg', 'afiq-free-rb-route-tree.jpg'].map(function (f, i) { return '<img src="' + esc((window.AFIQ_ASSET || '/') + f) + '" alt="" style="--i:' + i + '" loading="lazy">'; }).join('') +
        '</span><div class="adr-li-t"><b>3 free coaching sheets</b><small>QB homework, QB checklist, RB route tree. Emailed with your order.</small></div><div class="adr-li-p"><b class="adr-freetag">Free</b></div></li>' : '';
      this.body.innerHTML = '<ul class="adr-list">' + lines + free + '</ul>';
      if (this.offersEl) this.offersEl.innerHTML = this.renderOffers(c);
      this.renderTotals(c);
    }
    renderLadder(c) {
      var n = this.deckCount(c), T = (D._meta && D._meta.ladder) || [];
      if (!n || !A.tier || !T.length) { this.ladderEl.innerHTML = ''; return; }
      var cur = A.tier(n), next = A.nextTier(n), max = T[T.length - 1].min;
      var msg = next ? 'Add <b>' + (next.min - n) + ' more deck' + (next.min - n > 1 ? 's' : '') + '</b> for <b>' + next.pct + '% off every deck</b>' :
        '<b>' + cur.pct + '% off every deck</b>: the best price we offer';
      if (next && cur.pct) msg = '<b>' + cur.pct + '% off</b> unlocked. ' + msg;
      var pctW = Math.min(100, n / max * 100);
      this.ladderEl.innerHTML = '<p>' + msg + '</p><div class="adr-bar"><i style="width:' + pctW + '%"></i>' +
        T.filter(function (t) { return t.pct > 0; }).map(function (t) { return '<span class="' + (n >= t.min ? 'on' : '') + '" style="left:' + (t.min / max * 100) + '%">' + t.min + (t.min === max ? '+' : '') + '</span>'; }).join('') + '</div>';
    }
    renderOffers(c) {
      var html = '', inCart = function (id) { return c.items.some(function (i) { return P[id] && i.variant_id === P[id].variant; }); };
      this.plan = this.upgradePlan(c);
      /* the four volume boxes, fanned, so the offer reads as the product at a glance */
      var volArt = '<span class="adr-up-art" aria-hidden="true">' + VOL_IDS.filter(function (v) { return P[v].cutout; }).map(function (v, i) {
        return '<img src="' + esc(P[v].cutout_sm || P[v].cutout) + '" alt="" style="--i:' + i + '">'; }).join('') + '</span>';
      if (this.plan && ELITE) {
        html += '<div class="adr-up">' + volArt + '<div><span class="adr-eyebrow">Most popular</span><b>Upgrade to the full system</b>' +
          '<p>Swap ' + esc(this.plan.label) + ' for all four volumes (216 cards) for <b>' + money(this.plan.diff) + ' more</b>.</p></div>' +
          '<button type="button" class="adr-btn adr-btn--line" data-adr-upgrade>Upgrade · +' + money(this.plan.diff) + '</button></div>';
      } else if (ELITE && ELITE.available && !c.items.some(function (i) { var m = byVariant[i.variant_id]; return m && (m.kind === 'bundle' || m.p.kind === 'volume'); })) {
        /* no volumes or sets yet (Basics, Flag, gift card or PDFs only): offer the full system outright */
        html += '<div class="adr-up">' + volArt + '<div><span class="adr-eyebrow">Most popular</span><b>Add the full system</b><p>All four volumes, 216 cards.</p></div>' +
          '<button type="button" class="adr-btn adr-btn--line" data-adr-add="elite" data-variant="' + ELITE.variant + '">Add · ' + money(ELITE.price) + '</button></div>';
      }
      var rows = ['fl5', 'basics'].filter(function (id) { return P[id] && P[id].available && !inCart(id); }).map(function (id) {
        var x = P[id];
        return '<button type="button" class="adr-add" data-adr-add="' + id + '" data-variant="' + x.variant + '">' +
          '<span class="adr-add-box" aria-hidden="true">+</span>' + (x.cutout ? '<img src="' + esc(x.cutout_sm || x.cutout) + '" alt="" loading="lazy">' : '') +
          '<span class="adr-add-t"><b>Add ' + esc(x.short || x.label) + '</b><small>' + (id === 'fl5' ? 'For the 5v5 game' : 'For a brand-new player or parent') + (x.ladder ? ' · counts toward your deck discount' : '') + '</small></span>' +
          '<b class="adr-add-p">' + money(x.price) + '</b></button>';
      }).join('');
      if (rows) html += '<div class="adr-adds"><span class="adr-eyebrow">Complete the kit</span>' + rows + '</div>';
      return html;
    }
    renderTotals(c) {
      var save = c.original_total_price - c.total_price;
      this.codes.innerHTML = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) {
        return '<span class="adr-chip">' + esc(d.code) + '<button type="button" data-adr-rmcode="' + esc(d.code) + '" aria-label="Remove code ' + esc(d.code) + '">×</button></span>';
      }).join('');
      var hasPhysical = c.items.some(function (i) { return i.requires_shipping; });
      this.totals.innerHTML = '<div><dt>Subtotal</dt><dd>' + money(c.original_total_price) + '</dd></div>' +
        (save > 0 ? '<div class="adr-save"><dt>You save</dt><dd>−' + money(save) + '</dd></div>' : '') +
        (hasPhysical ? '<div><dt>Shipping</dt><dd>Free</dd></div>' : '') +
        '<div class="adr-total"><dt>Total</dt><dd>' + money(c.total_price) + '</dd></div>';
      var btn = this.querySelector('[data-adr-checkout]');
      if (btn) btn.textContent = 'Checkout · ' + money(c.total_price);
    }
    bubble(n) {
      var b = document.getElementById('cart-icon-bubble'); if (!b) return;
      var dot = b.querySelector('.cart-count-bubble');
      if (!n) { if (dot) dot.remove(); return; }
      if (!dot) { dot = document.createElement('div'); dot.className = 'cart-count-bubble'; b.appendChild(dot); }
      dot.innerHTML = '<span aria-hidden="true">' + (n < 100 ? n : '99+') + '</span><span class="visually-hidden">' + n + ' items in cart</span>';
    }
  }
  customElements.define('cart-drawer', AfiqCartDrawer);
  }
  /* Deferred scripts run before DOMContentLoaded (readyState is already 'interactive'), so wait for it; load is the fallback. */
  var started = false, go = function () { if (!started) { started = true; boot(); } };
  if (document.readyState === 'complete') go(); else { document.addEventListener('DOMContentLoaded', go); window.addEventListener('load', go); }
})();
